export default "__VITE_ASSET__da7139bd__"